import { createFileRoute } from "@tanstack/react-router";
import AdminOfflinePaymentsPage from "@/admin/pages/offline-payments";

export const Route = createFileRoute("/admin/offline-payments")({
  component: AdminOfflinePaymentsPage,
});
